import { useState } from "react";



const RedoImage: React.FunctionComponent<{ imageValue: any, onRedoImage: any }> = (props) => {


    const [isChangeRedo, setIsChangeRedo] = useState<boolean>(false);


    const RedoHandle = () => {
        if (!props.imageValue || !props.imageValue.id) {
            console.error('No image selected for redo');
            return;
        }
        
        setIsChangeRedo(true)
        props.onRedoImage(props.imageValue.id).then(() => {
            setIsChangeRedo(false);
        })
            .catch(() => {
                setIsChangeRedo(false);
            });
    }


    const isDisabled = !props.imageValue || !props.imageValue.id || isChangeRedo;

    return (
        <button 
            type="submit" 
            className={`button-reset back-trans border-black padd-10 ${isDisabled ? 'opacity-50' : ''}`} 
            onClick={RedoHandle}
            disabled={isDisabled}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_504_402)">
                    <path d="M15 14L19 10L15 6" stroke={isDisabled ? "#ccc" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M19 10H8C6.93913 10 5.92172 10.4214 5.17157 11.1716C4.42143 11.9217 4 12.9391 4 14C4 15.0609 4.42143 16.0783 5.17157 16.8284C5.92172 17.5786 6.93913 18 8 18H9" stroke={isDisabled ? "#ccc" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_504_402">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            {isChangeRedo && <div className="col-auto marg-left-5">
                <div className="spinner-border text-primary" style={{ width: "20px", height: "20px" }} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>}
        </button>
    )

}
export default RedoImage;